module.exports = __webpack_public_path__ + "static/media/img-01.8e586ed9.jpg";